import "./App.css";
import Main from "./components/main/Main";
import SideNav from "./components/sidenav/SideNav";
import Login from "./Login";
import Home from "./Home";
import {useState} from "react";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom"


function App() {
  const [user, setUser]=useState();

  return (
    <Router>
    <div className="App">
      {
        user ? (
          <Routes>
            <Route path="/" element={<Home/>}/>
          </Routes>
        ) :(
          <Login setUser ={setUser}/>
        )
      }
    </div>
    </Router>
  );
}

export default App;